"use client";

import "./spinner.css";
import Spinner from "@/components/Spinner/Spinner";
import { colors, fonts } from "@/stylingConstants";
import { useEffect, useRef } from "react";

export default function FullscreenSpinner({visible= true, size = '2.5rem'}) {
    const liveRegionRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        if (!visible) return;

        if (liveRegionRef.current) {
            liveRegionRef.current.textContent = 'Please wait';
        }

        const interval = setInterval(() => {
            if (liveRegionRef.current) {
                liveRegionRef.current.textContent = '';
                requestAnimationFrame(() => {
                    if (liveRegionRef.current) {
                        liveRegionRef.current.textContent = 'Please wait';
                    }
                });
            }
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, [visible]);

    return (
        <div 
        hidden={!visible} 
        className="span-col-full"
        style={{
            
            position: "absolute",
             width: '100%',
              height: '100vh' ,
              top:0, 
              backgroundColor: colors.darkCambridgeBlue,
               zIndex: 999
            }}>
            <div style={{marginTop: '160px', display: "flex", alignItems: "center", justifyContent: "center"}} aria-hidden="true">
                <Spinner size={size} />
            </div>
            <h1
                ref={liveRegionRef}
                aria-live="polite"
                aria-atomic="true"
                className="text-white text-center m-16"
                style={fonts.headerxl}
                >
                    Please wait
            </h1>
        </div>
    );
}